import { useCallback } from "react";

import { getPosition } from "../../../../utils";

import useIframeColorsList from "./useIframeColorsList";

const useScrollToIframeElement = (iframeRef, iframeWrapperRef) => {
    const { getElementByXpath } = useIframeColorsList(iframeRef);

    return useCallback(
        (xpath) => {
            const iframeWrapper = iframeWrapperRef.current;

            let elements;
            if(Array.isArray(xpath)) {
                elements = xpath.reduce(
                    (acc, item) => {
                        const newArr = getElementByXpath(item);

                        return [ ...acc, ...newArr ];
                    },
                    []
                );
            } else {
                elements = getElementByXpath(xpath);
            }

            if(!elements || !elements.length) {
                return;
            }

            if(elements.length) {
                const { top } = getPosition(elements[0], iframeRef);

                iframeWrapper.scrollTop = top - (30 + elements[0].offsetHeight);
            }
        },
        [ getElementByXpath, iframeRef, iframeWrapperRef ]
    );
};

export default useScrollToIframeElement;
